module.exports = __webpack_public_path__ + "static/fonts/iconfont.71a93646.ttf";